import { Row, Col, Form, Button, Modal, Card } from 'react-bootstrap';
import "./EditOrderModal.css"
import { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus, faCircleNotch  } from "@fortawesome/free-solid-svg-icons";
import NewModelModal from '../NewModelModal/NewModelModal';
import NewSerialModal from '../NewSerialModal/NewSerialModal';

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const EditOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const servicesURL = process.env.REACT_APP_SERVICES_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;
    const [customerID, setCustomerID] = useState(null);

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [customer, setCustomer] = useState(null);
    const [model, setModel] = useState(null);
    const [serialNumber, setSerialNumber] = useState(null);
    const [failure, setFailure] = useState(null);
    const [personContact, setPersonContact] = useState(null);
    const [personContactData, setPersonContactData] = useState(null);
    const [address, setAddress] = useState(null);

    //
    const [technicalName, setTechnicalName] = useState(null);
    const [serviceInvoice, setServiceInvoice] = useState(null);
    const [userTechnicalListing, setUserTechnicalListing] = useState([]);

    //
    const [technicalReport, setTechnicalReport] = useState(null);
    const [counterDevice, setcounterDevice] = useState(null);
    const [serviceType, setServiceType] = useState(null);
    const [notes, setNotes] = useState(null);

    //
    const [waitingFlag, setWaitingFlag] = useState(false);

    //
    const [objOrder, setObjOrder] = useState([]);

    //
    const [options_model, setOptionsModel] = useState([]);
    const [options_serials, setOptionsSerials] = useState([]);



    //ADD NEW MODEL MODAL
    const [showModal_AddModel, setShowModal_AddModel] = useState(false);   
    const requestCloseModal_AddModel = () => { 
        
        getModelsByCustomer();

        setShowModal_AddModel(false); 
    
    } //END

    const openModal_AddModel = () => { 
    
        if(!customerID) {


            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe seleccionar un cliente para poder agregar modelos.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }
        
        setShowModal_AddModel(true); 
    
    }//END

    //ADD NEW SERIAL MODAL
    const [showModal_AddSerial, setShowModal_AddSerial] = useState(false);   
    const requestCloseModal_AddSerial = () => { 
        
        getSerialsByModel();

        setShowModal_AddSerial(false); 
    
    } //END

    const openModal_AddSerial = () => { 
    
        if(!customerID) {


            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe seleccionar un cliente para poder agregar seriales.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }

        setShowModal_AddSerial(true); 
    
    } //END

    const getModelsByCustomer = async () => {


        if(customerID){
            
            const endpoint = "getModels?clienteId=" + customerID;
            console.log(servicesURL + endpoint);

            fetch(servicesURL + endpoint,
            {
                method: "GET",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
            }).then(async (response)=>{

                const responseContent = await response.json();

                
                let optionItems = [];

                let counter = 1;
                responseContent.forEach((item)=>{

                    let node = {
                        value: counter,
                        label: item
                    }

                    optionItems.push(node);

                    counter++;
                });
                
                setModel(null);
                setSerialNumber(null);
                setOptionsSerials([]);
                setOptionsModel(optionItems);
            });

        } //END IF


    } //END FUNCTION


    const getSerialsByModel = async () => {


       if(model){

  
            const endpoint = "getserials?clienteId=" + customerID + "&modelo=" + model.label;
            console.log(servicesURL + endpoint);

            fetch(servicesURL + endpoint,
            {
                method: "GET",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}

            }).then(async (response)=>{

                const responseContent = await response.json();

                let optionItems = [];

                let counter = 1;
                responseContent.forEach((item)=>{

                    let node = {
                        value: counter,
                        label: item.serial,
                        location: item.ubicacion
                    }

                    optionItems.push(node);

                    counter++;
                });

                setSerialNumber(null);
                setOptionsSerials(optionItems);
            });

        } //END IF
        

    } //END FUNCTION


    function getCurrentDateTimeInArgentina() {

        const now = new Date();
        const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));

        const year = argentinaTime.getFullYear();
        const month = String(argentinaTime.getMonth() + 1).padStart(2, '0');
        const day = String(argentinaTime.getDate()).padStart(2, '0');
        const hours = String(argentinaTime.getHours()).padStart(2, '0');
        const minutes = String(argentinaTime.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`;

    }//

    const editOrder = async () => {

        //MAIN VALIDATION
        if(!customer || !model || !serialNumber || !failure || !personContact || !address) {

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        //DATOS MINIMOS
        if(serialNumber.length < 4) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo Nro de Serie debe tener mínimo 4 caracteres.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }

        
        //
        const metadata = {
            "issuesDate": objOrder.issuesDate,
            "status": objOrder.status,
            "customer":customer,
            "model": model.label ? model.label.replace(/[\t\\']/g, '').trim() : "",
            "serialNumber":serialNumber.label ? serialNumber.label.replace(/[\t\\']/g, '').trim() : "",
            "failure": failure ? failure.replace(/[\t\\']/g, '').trim() : "",
            "personContact": personContact ? personContact.replace(/[\t\\']/g, '').trim() : "",
            "personContactData": personContactData ? personContactData.replace(/[\t\\']/g, '').trim() : "",
            "address": address ? address.replace(/[\t\\']/g, '').trim() : "",
            "notes": notes ? notes.replace(/[\t\\']/g, '').trim() : ""
          
        };
        
        
        //CONDICIONALES
        if(technicalName) { metadata.tecnico = technicalName; }
        if(technicalReport) { metadata.technicalReport = technicalReport.replace(/[\t\n\r\\']/g, ''); }
        if(counterDevice) { metadata.counterDevice = counterDevice.replace(/[\t\\']/g, '').trim(); }
        if(serviceInvoice) { metadata.serviceInvoice = serviceInvoice; }
        if(serviceType) { metadata.serviceType = serviceType; }

        //
        if(objOrder.customerSignature) { metadata.customerSignature = objOrder.customerSignature; }
        if(objOrder.signerName) { metadata.signerName = objOrder.signerName.replace(/[\t\\']/g, '').trim(); }
        if(objOrder.signerDNI) { metadata.signerDNI = objOrder.signerDNI.replace(/[\t\\']/g, '').trim(); }

        //
        if(objOrder.startServiceDate) { metadata.startServiceDate = objOrder.startServiceDate; }
        if(objOrder.closeServiceDate) { metadata.closeServiceDate = objOrder.closeServiceDate; }


        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";
        

        const endpoint = "updateOrder?orderID=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE CHANGE DETAILS
        let changeNotes = "";


        if(objOrder.model !== metadata.model) { changeNotes = changeNotes + "Modelo: " + objOrder.model + " > "  + metadata.model + "\n"; }
        if(objOrder.serialNumber !== metadata.serialNumber) { changeNotes = changeNotes + "Serial: " + objOrder.serialNumber + " > "  + metadata.serialNumber + "\n"; }
        if(failure && objOrder.failure !== metadata.failure) { changeNotes = changeNotes + "Falla: " + objOrder.failure + " > "  + metadata.failure + "\n"; }
        if(personContact && objOrder.personContact !== metadata.personContact) { changeNotes = changeNotes + "Persona Contacto: " + objOrder.personContact + " > "  + metadata.personContact + "\n"; }
        if(personContactData && objOrder.personContactData !== metadata.personContactData) { changeNotes = changeNotes + "Datos Contacto: " + objOrder.personContactData + " > "  + metadata.personContactData + "\n"; }
        if(address && objOrder.address !== metadata.address) { changeNotes = changeNotes + "Dirección: " + objOrder.address + " > "  + metadata.address + "\n"; }
        if(serviceInvoice && objOrder.serviceInvoice !== metadata.serviceInvoice) { changeNotes = changeNotes + "Serv. Facturable: " + objOrder.serviceInvoice + " > "  + metadata.serviceInvoice + "\n"; }
        if(technicalName && objOrder.tecnico !== metadata.tecnico) { changeNotes = changeNotes + "Técnico: " + objOrder.tecnico + " > "  + metadata.tecnico + "\n"; }
        if(notes && objOrder.notes !== metadata.notes) { changeNotes = changeNotes + "Notas: " + objOrder.notes + " > "  + metadata.notes + "\n"; }
        

        if(changeNotes !== "") { changeNotes = "Se cambiaron los siguientes campos:\n\n" + changeNotes; }
        else { changeNotes = "No se realizaron cambios sobre ningún campo."  }


        //STORE LOG INFORMATION
        storeOrderLog(responseContent.order_id, sessionUser.customer_name, "Edición del Servicio", changeNotes);

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //CLOSE MODAL
        requestClose(false);

    } //

    const requestOrderInfo = async () =>{


        //
        setWaitingFlag(true);


        //CLEAR SELECT IN MODAL
        setModel(null);

        let endpoint = "getOrderByID?order_id=" + orderID;

        let response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        let responseContent = await response.json();

        let metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);

        //
        setCustomer(metadata.customer);
        //setModel(metadata.model);
        setSerialNumber(metadata.serialNumber);
        setFailure(metadata.failure);
        setPersonContact(metadata.personContact);
        setPersonContactData(metadata.personContactData);
        setAddress(metadata.address);
        setNotes(metadata.notes);

        if(!metadata.notes) {setNotes("");}

        //
        setServiceInvoice(metadata.serviceInvoice);
        setTechnicalName(metadata.tecnico);

        //
        setTechnicalReport(metadata.technicalReport);
        setcounterDevice(metadata.counterDevice);
        setServiceType(metadata.serviceType);



        //
        //GET USERS
        endpoint = "getUsersListing";

        response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}

        }).then(async (response)=>  {


            responseContent = await response.json();
    
            //
            setWaitingFlag(false);

            //
            setUserTechnicalListing(responseContent);

            //GET CUSTOMER ID
            setCustomerID(responseContent.find(opt => opt.customer_name === metadata.customer).id);

        });

    } //END FUNCTION

   
    useEffect(()=>{ 
    
            //
            getModelsByCustomer();
            
        }, [customerID]);

      useEffect(()=>{ 
    
            //SET CURRENT MODEL
            setModel(options_model.find(opt => opt.label === objOrder.model));
           
        }, [options_model]);

       useEffect(()=>{ 
    
            //
            if(model){
                getSerialsByModel();
            }

        }, [model]);

        useEffect(()=>{ 
    

            //SET CURRENT MODEL
            setSerialNumber(options_serials.find(opt => opt.label === objOrder.serialNumber));

        }, [options_serials]);



    return (
        <>
        <Modal show={show} onShow={requestOrderInfo} onHide={requestClose} className={'mainOrderModal'} size="lg">
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Editar Orden de Servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    {waitingFlag ? 
                        <Row style={{textAlign:"center", color: "darkred"}}>
                            <Col>
                                <FontAwesomeIcon 
                                    spin
                                    icon={faCircleNotch } 
                                    style={{}} 
                                /> <span>Obteniendo datos, por favor espere...</span>
                            </Col>
                        </Row>
                        : 
                    (
                     <>
                     <Card variant="primary">
                        <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Servicio</Card.Header>
                        <Card.Body>

                            
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Cliente</Form.Label>
                                        <Form.Control 
                                                type="text" 
                                                value={customer} 
                                                disabled="disabled"
                                        />
                                        <br />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Modelo</Form.Label>
                                        <Select 
                                            style={{fontSize:"14px"}}
                                            options={options_model}
                                            value={model}
                                            placeholder="-- Selecciona un Modelo --"
                                            onChange={(selectedOption) => { setModel(selectedOption); }}
                                            >
                                        </Select>
                                        <Button 
                                            size='sm' 
                                            variant="outline-info" 
                                            style={{color:"#666666", fontSize: "10px", marginTop: "5px"}}
                                            onClick = {openModal_AddModel}
                                            >
                                            ➕ Modelo
                                        </Button>
                                        <br /><br />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>N° de Serie</Form.Label>
                                       <Select 
                                            style={{fontSize:"14px"}}
                                            options={options_serials}
                                            value={serialNumber}
                                            onChange={(selectedOption) => {setSerialNumber(selectedOption); setAddress(selectedOption.location); } }
                                            placeholder="-- Selecciona un serial --"
                                            >
                                        </Select>
                                        <Button 
                                            size='sm' 
                                            variant="outline-info" 
                                            style={{color:"#666666", fontSize: "10px", marginTop: "5px"}} 
                                            onClick = {openModal_AddSerial}
                                            >
                                            ➕ Serial
                                        </Button>
                                        <br /> <br />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Falla / Detalles</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Falla del equipo" 
                                        value={failure}
                                        maxLength={200} 
                                        onChange={(event)=> setFailure(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Persona Contacto</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Nombre y apellido del solicitante..." 
                                        value={personContact}
                                        maxLength={80} 
                                        onChange={(event)=> setPersonContact(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label>Datos del Contacto</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Teléfono / Email" 
                                        value={personContactData}
                                        maxLength={80} 
                                        onChange={(event)=> setPersonContactData(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Dirección del Servicio</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Direccion..." 
                                        value={address}
                                        maxLength={200} 
                                        onChange={(event)=> setAddress(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Notas / Observaciones</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Notas varias..." 
                                        value={notes}
                                        maxLength={200} 
                                        onChange={(event)=> setNotes(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>
                            </Row>

                            
                        </Card.Body>
                    </Card>

                    <br />

                    { objOrder.status === "Técnico asignado" || objOrder.status === "Servicio en pausa" ? (
                    <Card variant="primary">
                        <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Técnico</Card.Header>
                        <Card.Body>

                            <Col xs={12}>
                                <Form.Label className='newOrderlabels'>Servicio Facturable: </Form.Label>
                                <Form.Select value={serviceInvoice} style={{fontSize:"13px"}} onChange={(e)=>{setServiceInvoice(e.target.value); }} >
                                    <option style={{fontSize:"14px"}} value="">Seleccione...</option>
                                    <option style={{fontSize:"14px"}} value="No">No</option>
                                    <option style={{fontSize:"14px"}} value="Si">Si</option>
                                </Form.Select>
                            </Col>
                            <br />
                            <Col xs={12}>
                                <Form.Group>
                                    <Form.Label className='newOrderlabels'>Listado de Técnicos</Form.Label>
                                    <Form.Select value={technicalName} style={{fontSize:"13px"}} onChange={(e)=>{setTechnicalName(e.target.value); }} >
                                        <option style={{fontSize:"14px"}}>Seleccione...</option>
                                        {userTechnicalListing.map((item)=>{

                                            return(
                                                (item.groupname === "Técnicos" ? (
                                                    <option style={{fontSize:"14px"}}>{item.customer_name}</option>
                                                ) : "" )
                                            )

                                        })}
            
                                    </Form.Select> <br />
                                </Form.Group>
                            </Col>
                        
                        </Card.Body>
                    </Card>

                    ) : "" }

                    <br />

                    { objOrder.technicalReport ? (
                        <Card variant="primary">
                            <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Informe</Card.Header>
                            <Card.Body>

                                <Row>
                                    <Col xs={12}>
                                        <Form.Label className={'newOrderlabels'}>Informe Técnico</Form.Label>
                                        <Form.Control as="textarea" rows={5} onChange={(event)=> setTechnicalReport(event.target.value)} value={technicalReport} /><br />
                                    </Col>

                                    <Col xs={6}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Contador</Form.Label>
                                            <Form.Control 
                                            type="text" 
                                            placeholder="Direccion..." 
                                            value={counterDevice}
                                            maxLength={200} 
                                            onChange={(event)=> setcounterDevice(event.target.value)} /><br />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={6}>
                                        <Form.Label className={'newOrderlabels'}>Tipo de Servicio</Form.Label>
                                            <Form.Select value={serviceType} style={{fontSize:"13px"}} onChange={(e)=>{setServiceType(e.target.value); }} >
                                                <option style={{fontSize:"14px"}} value="">Seleccione...</option>
                                                <option style={{fontSize:"14px"}} value="Remoto">Remoto</option>
                                                <option style={{fontSize:"14px"}} value="Presencial">Presencial</option>
                                            </Form.Select>
                                    </Col>
                                </Row>
                            
                            </Card.Body>
                        </Card>
                    ) : "" }

                    </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={editOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>


         {/* MODAL */}
        <NewModelModal show={showModal_AddModel} requestClose={requestCloseModal_AddModel} selectedClientID={customerID} />

        {/* MODAL */}
        <NewSerialModal show={showModal_AddSerial} requestClose={requestCloseModal_AddSerial} selectedClientID={customerID}/>

        </>
    );
}

export default EditOrderModal;